function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createSelector } from 'reselect';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import clone from 'ramda/src/clone';
import find from 'ramda/src/find';
import groupBy from 'ramda/src/groupBy';
import map from 'ramda/src/map';
import path from 'ramda/src/path';
import pathOr from 'ramda/src/pathOr';
import prop from 'ramda/src/prop';
import propEq from 'ramda/src/propEq';
import values from 'ramda/src/values';
import Immutable from 'seamless-immutable';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { CustomerInfoSelector, EditCartSelector } from './new.connect.wizard.selectors';
import { CurrentCustomerSelector as CustomerSelectorsCurrentCustomerSelector, CustomerStoreSelector as CustomerSelectorsCustomerStoreSelector, SelectedCustomerSelector as CustomerSelectorsSelectedCustomerSelector } from 'invision-core/src/components/customer/customer.selectors';
import { getSecurityAttributeById, hasAccess } from 'invision-core/src/components/security/permission.service';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { ActiveSubtenantsSelector } from 'invision-core/src/components/subtenants/subtenants.selectors';
import { MetadataCodeTypeSelector, MetadataCodeTypeDictionarySelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { selectOptionsForCodeNames, selectOptionsForCodeNamesWithCustomOption } from 'invision-core/src/components/metadata/codes/codes.helpers';
import { addressStateRegionProvinceValueOptionsForCountry, consentsForCountry, currencyValuesForCountry, currencyValueOptionsForCountry, getCustomerAdditionalPropertiesSortedByDisplayOrder, getCustomerCurrencyName, getCustomerHomeCountryName, getCustomerInvoiceDetailStatus, getPreferredTaxDefaultCurrency, selectOptionsForAlphabetizedCurrencyValues } from '../helpers/customer.selectors.helpers';
import { ADJUSTMENT_LIMIT_AND_ACCESS, BILL_CYCLE_CHANGE_ACCESS, FINANCE_ADJUSTMENT_LIMIT_AND_ACCESS, PII_ACCESS, SUBSCRIBER_BYPASS_RESET_PASSWORD, UPDATE_PIN_ACCESS } from '../../security.attributes';
import { INVALID_SHOPPING_CART_FAULT_CODE, SUBSCRIBER_TYPE_CODES } from '../../customercare.constants';
import { getCustomerIdentifier } from '../helpers/customer.helper';
import LocaleKeys from '../../locales/keys';
import { CUSTOMER_CATEGORY } from '../../components/createCustomerPopup/create.customer.popup.constants';
import { ShowCustomerAutoPayBannerSelector } from './customer.account.status.selectors';
import { CUSTOMER_STATE } from '../../components/shared/constants/customer.constants';
import { findByKey } from 'invision-core/src/utilities/ramda.helper';
import { getBoolOrDefault } from 'invision-core/src/components/helpers/bool.helper';
import { SubscriberAdditionalPropertiesSelector } from 'invision-core/src/components/metadata/codes/codes.additional.properties.selectors';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { DASHBOARD_ROUTE } from '../constants/dashboard.constants';
import { RouteCurrentStateSelector } from 'invision-core/src/components/router/router.selectors';
import { getChargeTypesForDetailedTaxation } from '../../components/createCustomer/tax.model.helper';
import { FeatureTogglesSelector } from 'invision-core/src/components/featureToggle/featureToggle.selectors';
import { FeatureToggleConstants } from 'invision-core';
var EMPTY_OBJECT = Immutable({});
export var EMPTY_ARRAY = Immutable([]);
export var CustomerStoreSelector = CustomerSelectorsCustomerStoreSelector;
export var SelectedCustomerSelector = CustomerSelectorsSelectedCustomerSelector;
export var CurrentCustomerSelector = CustomerSelectorsCurrentCustomerSelector;
export var RouteParams = function RouteParams(state) {
  return state.router.currentParams;
};
export var RouteState = function RouteState(state) {
  return state.router.currentState;
};
export var RoutePreviousState = function RoutePreviousState(state) {
  return state.router.prevState;
};
export var CreditCheckConfigurationSelector = function CreditCheckConfigurationSelector(state) {
  return pathOr(null, ['customercare', 'config', 'creditCheck'], state);
};
export var CurrentCustomerStateSelector = createSelector([CurrentCustomerSelector], function (currentCustomer) {
  return currentCustomer.State;
});
export var CurrentCustomerReadinessSelector = createImmutableSelector([CurrentCustomerSelector], function (currentCustomer) {
  return currentCustomer.SubscriberReadiness || EMPTY_OBJECT;
});
export var IsCurrentCustomerReadyForOrdersSelector = createImmutableSelector([CurrentCustomerReadinessSelector, IsDbss], function (currentCustomerReadiness, isDbss) {
  return isDbss ? currentCustomerReadiness.ReadyForOrders : true;
});
export var IsCurrentCustomerBlocklisted = createSelector([CurrentCustomerStateSelector], function (currentCustomerState) {
  var flag = false;
  if (currentCustomerState) {
    flag = currentCustomerState === CUSTOMER_STATE.BLOCKLISTED.toString();
  }
  return flag;
});
export var SelectedCustomerCreditCheckDetailsSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return path(['creditCheck'], selectedCustomer);
});
export var SelectedCustomerIsCreditCheckSkippedSelector = createSelector([SelectedCustomerCreditCheckDetailsSelector], function (subscriberCreditCheck) {
  return subscriberCreditCheck.isCreditCheckSkipped;
});
export var CurrentCustomerIdSelector = createSelector([RouteParams], function (routeParams) {
  return routeParams.customerId;
});
export var CurrentOrderIdSelector = createSelector([RouteParams], function (routeParams) {
  return routeParams.orderId;
});
export var CurrentAccountNumberSelector = createSelector([RouteParams, CurrentCustomerSelector], function (routeParams, currentCustomer) {
  var _currentCustomer$Subs;
  return routeParams.accountNumber || (currentCustomer === null || currentCustomer === void 0 ? void 0 : (_currentCustomer$Subs = currentCustomer.SubscriberTypeDetails) === null || _currentCustomer$Subs === void 0 ? void 0 : _currentCustomer$Subs.PostpaidAccountNumber);
});
export var CurrentServiceIdSelector = createSelector([RouteParams], function (routeParams) {
  return routeParams.serviceId;
});
export var GdprConsentsSelector = createSelector([MetadataCodeTypeSelector(CODES.Consents)], function (consents) {
  return consents;
});
export var IsGdprCompliantSelector = createSelector(GdprConsentsSelector, function (consents) {
  return consents.length > 0;
});
export var ShowAutoPayBannerSelector = createSelector([RouteParams, ShowCustomerAutoPayBannerSelector], function (routeParams, showBanner) {
  return routeParams && routeParams.showAutoPayBanner && routeParams.showAutoPayBanner.enabled && showBanner && routeParams.showAutoPayBanner.customerId === parseInt(routeParams.customerId);
});
export var ShowDetailedTaxationPerformanceBannerSelector = createImmutableSelector([RouteCurrentStateSelector, CurrentCustomerSelector, SubscriberRequirementsForCurrentBusinessUnitOrDefault, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault], function (routeCurrentState, currentCustomer, subscriberRequirements, subscriberCategoryRequirements) {
  var _currentCustomer$Char;
  var requirements = currentCustomer.Category === CUSTOMER_CATEGORY.RESIDENTIAL ? subscriberRequirements : subscriberCategoryRequirements;
  return routeCurrentState.name === DASHBOARD_ROUTE && ((_currentCustomer$Char = currentCustomer.ChargeTypesForDetailedTaxation) === null || _currentCustomer$Char === void 0 ? void 0 : _currentCustomer$Char.length) && requirements.enable_charge_types_for_detailed_taxation;
});
export var PreviousSubscriptionSelector = createSelector([RouteParams], function (routeParams) {
  return routeParams.subscription;
});
export var CurrentCustomerConvergentBillerIdSelector = createSelector([CustomerStoreSelector], function (customerStore) {
  return pathOr('', ['selectedCustomer', 'data', 'ConvergentBillerId'], customerStore);
});
export var SelectedCustomerCategorySelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.category;
});
export var SelectedCustomerRequirements = createSelector([SelectedCustomerCategorySelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault], function (customerCategory, customerCategoryRequirements, customerRequirements) {
  if (customerCategory === CUSTOMER_CATEGORY.COMMERCIAL) {
    return customerCategoryRequirements;
  } else {
    return customerRequirements;
  }
});
export var CustomerPinRegexSelector = createImmutableSelector([SelectedCustomerRequirements, MetadataCodeTypeDictionarySelector(CODES.RegularExpression)], function (customerRequirements, regexCodes) {
  return path(['AdditionalProperties', 'regex'], Object.values(regexCodes).find(function (item) {
    return item.Value === customerRequirements.subscriber_pin_regex;
  }));
});
export var EnableProspectLiteSelector = createImmutableSelector([SelectedCustomerCategorySelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault], function (customerCategory, commercialCustomerRequirements, residentialCustomerRequirements) {
  return customerCategory === CUSTOMER_CATEGORY.COMMERCIAL ? commercialCustomerRequirements.enable_prospect_lite === true : residentialCustomerRequirements.enable_prospect_lite === true;
});
export var EnableProspectLiteForHouseholdSelector = createImmutableSelector([SelectedCustomerCategorySelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault], function (customerCategory, commercialCustomerRequirements, residentialCustomerRequirements) {
  return customerCategory === CUSTOMER_CATEGORY.COMMERCIAL ? commercialCustomerRequirements.enable_prospect_lite_for_household === true : residentialCustomerRequirements.enable_prospect_lite_for_household === true;
});
export var DefaultPasswordChallengeOptionsWithCustomValidation = createSelector([MetadataCodeTypeSelector(CODES.DefaultPasswordChallenge), SelectedCustomerRequirements], function (challenges, subscriberRequirements) {
  if (!challenges.length) {
    return EMPTY_ARRAY;
  }
  return subscriberRequirements.enable_custom_password_challenge ? selectOptionsForCodeNamesWithCustomOption(challenges) : selectOptionsForCodeNames(challenges);
});
export var SelectedCustomerIsSsnRequired = createSelector([SelectedCustomerRequirements, CreditCheckConfigurationSelector, SelectedCustomerIsCreditCheckSkippedSelector], function (requirements, creditCheckConfiguration, selectedCustomerIsCreditCheckSkipped) {
  return requirements.capture_ssn || creditCheckConfiguration.creditCheckModalStatus && requirements.capture_ssn_for_credit_check && !selectedCustomerIsCreditCheckSkipped;
});
export var SelectedCustomerIsDriversLicenseRequired = createSelector([SelectedCustomerRequirements, CreditCheckConfigurationSelector, SelectedCustomerIsCreditCheckSkippedSelector], function (requirements, creditCheckConfiguration, selectedCustomerIsCreditCheckSkipped) {
  return requirements.capture_drivers_license_number || creditCheckConfiguration.creditCheckModalStatus && requirements.capture_drivers_license_number_for_credit_check && !selectedCustomerIsCreditCheckSkipped;
});
export var SelectedCustomerIsDateOfBirthRequired = createSelector([SelectedCustomerRequirements, CreditCheckConfigurationSelector, SelectedCustomerIsCreditCheckSkippedSelector], function (requirements, creditCheckConfiguration, selectedCustomerIsCreditCheckSkipped) {
  return requirements.capture_birthdate || creditCheckConfiguration.creditCheckModalStatus && requirements.capture_birthdate_for_credit_check && !selectedCustomerIsCreditCheckSkipped;
});
export var SelectedCustomerHomeCountrySelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(null, ['data', 'HomeCountry'], selectedCustomer);
});
export var SelectedCustomerSubtenantSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr('0', ['data', 'SubtenantId', 'Value'], selectedCustomer);
});

// Returns the subscriber consents as-is provided by the API
export var SelectedCustomerSubscriberConsentsSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr([], ['data', 'SubscriberConsents'], selectedCustomer);
});
export var SelectedCustomerAllConsentsSelector = createSelector([GdprConsentsSelector, SelectedCustomerSubscriberConsentsSelector], function (consents, selectedCustomerSubscriberConsents) {
  var allBUConsents = consentsForCountry(null, consents);
  if (allBUConsents.length > 0) {
    var customerConsentsMap = {};
    selectedCustomerSubscriberConsents.forEach(function (c) {
      customerConsentsMap[c.ConfigConsentId] = {
        isAccepted: c.ConsentAccepted,
        acceptanceDateTime: c.ConsentDateTime
      };
    });
    return allBUConsents.map(function (c) {
      if (customerConsentsMap[c.id]) {
        c.isAccepted = customerConsentsMap[c.id].isAccepted;
        c.isModifiedAfterAcceptance = !customerConsentsMap[c.id].acceptanceDateTime;
      }
      return c;
    });
  } else {
    return [];
  }
});

// Returns Consents from the Metadata Store that are configured for the HomeCountry
export var SelectedCustomerConsentsSelector = createSelector([GdprConsentsSelector, SelectedCustomerHomeCountrySelector, SelectedCustomerSubscriberConsentsSelector], function (consents, selectedCustomerHomeCountry, selectedCustomerSubscriberConsents) {
  var configuredConsents = consentsForCountry(selectedCustomerHomeCountry, consents);
  if (configuredConsents.length > 0) {
    var customerConsentsMap = {};
    selectedCustomerSubscriberConsents.forEach(function (c) {
      customerConsentsMap[c.ConfigConsentId] = {
        isAccepted: c.ConsentAccepted,
        acceptanceDateTime: c.ConsentDateTime
      };
    });
    return configuredConsents.map(function (c) {
      if (customerConsentsMap[c.id]) {
        c.isAccepted = customerConsentsMap[c.id].isAccepted;
        c.isModifiedAfterAcceptance = !customerConsentsMap[c.id].acceptanceDateTime;
      }
      return c;
    });
  } else {
    return [];
  }
});
export var SelectedCustomerConsentsMandatorySelector = createSelector([SelectedCustomerConsentsSelector], function (consents) {
  return consents.filter(function (c) {
    return c.isRequired;
  });
});
export var SelectedCustomerConsentsMandatoryAcceptedSelector = createSelector([SelectedCustomerConsentsMandatorySelector], function (consents) {
  return consents.filter(function (c) {
    return c.isAccepted;
  });
});

// Returns the unaccepted mandatory consents for the selected customer. These unaccepted contents are the ones that were added after the Customer last gave his/her consent.
export var SelectedCustomerConsentsMandatoryUnacceptedSelector = createSelector([SelectedCustomerConsentsMandatorySelector], function (consents) {
  return consents.filter(function (c) {
    return !c.isAccepted || c.isModifiedAfterAcceptance;
  });
});
export var SelectedCustomerConsentsOptionalSelector = createSelector([SelectedCustomerConsentsSelector], function (consents) {
  return consents.filter(function (c) {
    return !c.isRequired;
  });
});
export var SelectedCustomerIsConsentTermsSentSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.isConsentTermsSent;
});
export var ShoppingCartSelector = createSelector([CustomerStoreSelector], function (customerStore) {
  return customerStore.shoppingCart;
});
export var InstanceLevelOrderedSelector = createSelector([CustomerStoreSelector], function (customerStore) {
  return customerStore.instanceLevelOrdered;
});
export var StoreOrderSelector = createImmutableSelector([CustomerStoreSelector], function (customerStore) {
  return customerStore.storeOrder;
});
export var StoreOrderErrorSelector = createImmutableSelector([CustomerStoreSelector], function (customerStore) {
  return customerStore.storeOrderError;
});
export var StoreOrderShoppingCartSelector = createImmutableSelector([StoreOrderSelector], function (storeOrder) {
  return storeOrder && storeOrder.ShoppingCart || EMPTY_OBJECT;
});
export var StoreOrderTypeSelector = createImmutableSelector([StoreOrderSelector], function (storeOrder) {
  return storeOrder.Action || null;
});
export var InvalidInventoryItemSelector = createSelector([CustomerStoreSelector], function (customerStore) {
  return customerStore.invalidInventory;
});
export var CurrentCustomerBillCycleSelector = createSelector([CurrentCustomerSelector], function (currentCustomer) {
  return currentCustomer.SubscriberTypeDetails && currentCustomer.SubscriberTypeDetails.BillCycle ? currentCustomer.SubscriberTypeDetails.BillCycle : null;
});
export var CurrentCustomerNewBillCycleSelector = createImmutableSelector([CurrentCustomerSelector], function (currentCustomer) {
  var _currentCustomer$Subs2;
  return (currentCustomer === null || currentCustomer === void 0 ? void 0 : (_currentCustomer$Subs2 = currentCustomer.SubscriberTypeDetails) === null || _currentCustomer$Subs2 === void 0 ? void 0 : _currentCustomer$Subs2.NewBillCycle) || null;
});
export var CurrentCustomerSubtenantSelector = createImmutableSelector([CurrentCustomerSelector, ActiveSubtenantsSelector], function (customer, subtenants) {
  return subtenants && customer.SubtenantId && (subtenants.find(function (subtenant) {
    return subtenant.Id.Value === customer.SubtenantId.Value;
  }) || {}).Name;
});
export var CurrentCustomerIsExternallyManagedARSelector = createSelector([CurrentCustomerSelector, MetadataCodeTypeSelector(CODES.SubscriberType)], function (currentCustomer, subscriberTypes) {
  var subscriberType = subscriberTypes.find(function (subscriberType) {
    return subscriberType.Value === currentCustomer.SubscriberTypeCode;
  });
  return !!(subscriberType && subscriberType.AdditionalProperties.find(propEq('externally_managed_accounts_receivable', 'Key')).Value === 'True');
});
export var HasConvergentBillerIdSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return !!selectedCustomer.data.ConvergentBillerId;
});
export var CurrentCustomerSubscriberAccountsSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.subscriberAccounts;
});
export var CurrentCustomerResponsibilityAccountsItemsSelector = createSelector([CurrentCustomerSelector, CurrentCustomerSubscriberAccountsSelector], function (currentCustomer, currentCustomerSubscriberAccounts) {
  if (!currentCustomerSubscriberAccounts) {
    return null;
  }
  var buildGroupItems = function buildGroupItems(group) {
    return map(function (item) {
      return {
        title: item.hierarchyNodeName,
        customerId: item.customerId
      };
    })(group);
  };
  var groups = [];
  var residentialSubscriberAccountsGroup;
  var groupedSubscriberAccounts = groupBy(prop('hierarchyId'))(currentCustomerSubscriberAccounts);
  values(groupedSubscriberAccounts).forEach(function (subscriberAccountsGroup) {
    //if (subscriberAccountsGroup[0].hierarchyRootSubscriberId === currentCustomer.Id) {
    // really, we should check that the subscriber is the root of the hierarchy
    // because subscribers are limited to a single hierarchy currently, and the root node data is not made
    // available, comparing hierarchy identifiers is well enough
    if (subscriberAccountsGroup[0].hierarchyId === currentCustomer.HierarchyId && parseInt(currentCustomer.SubscriberTypeCode, 10) === SUBSCRIBER_TYPE_CODES.RESIDENTIAL) {
      // specialize on Subscriber's own hierarchy as "Residential", store for later placement atop the list
      residentialSubscriberAccountsGroup = subscriberAccountsGroup;
      return;
    }
    groups.push({
      title: subscriberAccountsGroup[0].hierarchyName,
      items: buildGroupItems(subscriberAccountsGroup)
    });
  });
  if (residentialSubscriberAccountsGroup) {
    groups.unshift({
      title: i18n.translate(LocaleKeys.RESIDENTIAL),
      items: buildGroupItems(residentialSubscriberAccountsGroup)
    });
  }
  return groups;
});
export var SelectedResponsibilityAccountsItemSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.selectedSubscriberAccount;
});
export var SubtenantOptionsSelector = createSelector([ActiveSubtenantsSelector], function (subtenants) {
  return subtenants && subtenants.map(function (subtenant) {
    return {
      label: subtenant.Name,
      value: subtenant.Id.Value
    };
  });
});
export var CurrentCustomerExternalAuthorizationsSelector = createSelector([SelectedCustomerSelector, MetadataCodeTypeSelector(CODES.ExternalAuthorizationProvider)], function (selectedCustomer, externalAuthorizationProviders) {
  if (!selectedCustomer || !selectedCustomer.data || !selectedCustomer.data.ExternalAuthorizations) {
    return [];
  }
  return selectedCustomer.data.ExternalAuthorizations.map(function (externalAuthorization) {
    if (externalAuthorization.length === 0) {
      return {};
    }
    var tableRow = {};
    tableRow.id = externalAuthorization.Id;
    tableRow.externalSubscriberId = externalAuthorization.SubscriberExternalReference ? externalAuthorization.SubscriberExternalReference : i18n.translate(LocaleKeys.NO_RESULTS);
    tableRow.tokenActive = externalAuthorization.TokenActive ? externalAuthorization.TokenActive : i18n.translate(LocaleKeys.NO_RESULTS);
    tableRow.expirationDate = externalAuthorization.Expiration ? externalAuthorization.Expiration : i18n.translate(LocaleKeys.NO_RESULTS);
    var provider = externalAuthorizationProviders.find(function (item) {
      return item.Value === "".concat(externalAuthorization.Provider);
    });
    tableRow.name = provider ? provider.Name : i18n.translate(LocaleKeys.NO_RESULTS);
    return tableRow;
  });
});
export var ShoppingCartErrorSelector = createSelector([CustomerStoreSelector], function (customerStore) {
  return customerStore.shoppingCartError;
});
var showExistingCart = function showExistingCart(cart, error) {
  return !!pathOr(0, ['Items', 'length'], cart) || path(['code'], error) === INVALID_SHOPPING_CART_FAULT_CODE;
};
export var IsExistingCartSelector = createSelector([ShoppingCartSelector, ShoppingCartErrorSelector], function (shoppingCart, shoppingCartError) {
  return showExistingCart(shoppingCart, shoppingCartError);
});
export var IsTransferCartFromCurrentCustomerSelector = createImmutableSelector([ShoppingCartSelector], function (shoppingCart) {
  return shoppingCart && !!shoppingCart.TransferFromSubscriberId;
});
export var IsExistingStoreOrderSelector = createImmutableSelector([StoreOrderShoppingCartSelector, StoreOrderErrorSelector], function (storeOrderShoppingCart, storeOrderError) {
  return showExistingCart(storeOrderShoppingCart, storeOrderError);
});
export var IsCreatingCustomerSelector = createSelector([CustomerStoreSelector], function (customerStore) {
  return customerStore.isCreatingCustomer;
});
export var IsCreatingHierarchySelector = createSelector([CustomerStoreSelector], function (customerStore) {
  return customerStore.isCreatingHierarchy;
});
export var CurrentCustomerNameSelector = createSelector([CurrentCustomerSelector], function () {
  var customer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return getCustomerIdentifier(customer);
});
export var ViewLastAttemptErrorSelector = createSelector([CustomerStoreSelector], function () {
  var customer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return customer.lastAttemptError;
});
export var SelectedTabServicesAndOffersSelector = createImmutableSelector([CustomerStoreSelector], function (customer) {
  return customer.selectedTabServicesAndOffersWidget;
});
export var CreateEditCustomerSelector = createSelector([CustomerStoreSelector], function () {
  var customer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return customer.createCustomerModel ? customer.createCustomerModel.asMutable({
    deep: true
  }) : {};
});
export var CurrentCustomerIsRootNodeSelector = createImmutableSelector([CurrentCustomerSelector], function (currentCustomer) {
  return currentCustomer.HierarchyId && !currentCustomer.HierarchyParentSubscriberId;
});
export var CurrentCustomerIsInHierarchySelector = createImmutableSelector([CurrentCustomerSelector], function (currentCustomer) {
  return currentCustomer.HierarchyId;
});
export var EditCustomerIsRootNodeSelector = createImmutableSelector([CreateEditCustomerSelector], function (editCustomer) {
  return editCustomer.HierarchyId && !editCustomer.HierarchyParentSubscriberId;
});
export var EditCustomerIsInHierarchySelector = createImmutableSelector([CreateEditCustomerSelector], function (editCustomer) {
  return editCustomer.HierarchyId;
});
export var IsEditCustomerHierarchyRootOrNotInHierarchySelector = createImmutableSelector([EditCustomerIsInHierarchySelector, EditCustomerIsRootNodeSelector], function (customerIsInHierarchy, customerIsRootNode) {
  return !customerIsInHierarchy || customerIsRootNode;
});
export var IsCurrentCustomerHierarchyRootOrNotInHierarchySelector = createImmutableSelector([CurrentCustomerIsInHierarchySelector, CurrentCustomerIsRootNodeSelector], function (customerIsInHierarchy, customerIsRootNode) {
  return !customerIsInHierarchy || customerIsRootNode;
});
export var CreateEditCustomerConsentsSelector = createSelector([GdprConsentsSelector, CreateEditCustomerSelector], function (consents, createEditCustomer) {
  var homeCountry = createEditCustomer.HomeCountry;
  return consentsForCountry(homeCountry, consents);
});
export var NewConnectCustomerConsentsSelector = createSelector([GdprConsentsSelector, EditCartSelector], function (consents, createEditCustomer) {
  var homeCountry = createEditCustomer.customerInfo.HomeCountry;
  return consentsForCountry(homeCountry, consents);
});
export var CreateCustomerConsentsMandatorySelector = createSelector([CreateEditCustomerConsentsSelector], function (consents) {
  return consents.filter(function (c) {
    return c.isRequired;
  });
});
export var CreateEditCustomerConsentsOptionalSelector = createSelector([CreateEditCustomerSelector, CreateEditCustomerConsentsSelector, SelectedCustomerConsentsOptionalSelector], function (createEditCustomer, consents, selectedCustomerOptionalConsents) {
  if (createEditCustomer.Id) {
    return consents.filter(function (c) {
      if (!c.isRequired) {
        var matchedConsent = find(propEq(c.id, 'id'), selectedCustomerOptionalConsents);
        if (matchedConsent) {
          c.isAccepted = matchedConsent.isAccepted;
        }
        return true;
      }
      return false;
    });
  } else {
    return consents.filter(function (c) {
      c.isAccepted = undefined;
      return !c.isRequired;
    });
  }
});
export var CreateChildCustomerSelector = createSelector([CustomerStoreSelector, CurrentCustomerSelector], function () {
  var customer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var currentCustomer = arguments.length > 1 ? arguments[1] : undefined;
  return customer.createCustomerModel ? customer.createCustomerModel.merge({
    HomeCountry: pathOr(null, ['createCustomerModel', 'HomeCountry'], customer) || pathOr(null, ['HomeCountry'], currentCustomer),
    SubscriberCurrency: pathOr(null, ['createCustomerModel', 'SubscriberCurrency'], customer) || pathOr(null, ['SubscriberCurrency'], currentCustomer)
  }, {
    deep: true
  }).asMutable({
    deep: true
  }) : {};
});
export var CreateCustomerStateRegionProvinceValueOptions = createSelector([CreateEditCustomerSelector, MetadataCodeTypeSelector(CODES.AddressCountry), MetadataCodeTypeSelector(CODES.AddressStateProvinceRegion)], function (customer, countryCodes, stateCodes) {
  return addressStateRegionProvinceValueOptionsForCountry(customer.HomeCountry, countryCodes, stateCodes);
});
export var CustomerIsFetchingDataSelector = createSelector([CustomerStoreSelector], function (customer) {
  return customer.isFetchingData;
});

// Returns only those mandatory consents that have not been accepted by the customer.
export var EditCustomerConsentsMandatorySelector = createSelector([CreateEditCustomerConsentsSelector, SelectedCustomerAllConsentsSelector], function (consents, selectedCustomerAllConsents) {
  return consents.filter(function (c) {
    if (c.isRequired) {
      var matchedConsent = find(propEq(c.id, 'id'), selectedCustomerAllConsents);
      return matchedConsent && matchedConsent.isAccepted && !matchedConsent.isModifiedAfterAcceptance ? false : true;
    }
    return false;
  });
});
export var IsEditingProfileSelector = createSelector([CustomerStoreSelector], function (customer) {
  return customer.isEditingProfile;
});
export var SelectedCustomerAdditionalPropertiesSelector = createImmutableSelector([CurrentCustomerSelector], function (customer) {
  return customer.AdditionalProperties || EMPTY_ARRAY;
});
export var IsSelectedCustomerWithPinSelector = createImmutableSelector([CurrentCustomerSelector], function (customer) {
  return customer.SubscriberPinSetup || false;
});
export var SelectedCustomerAdditionalPropertiesSortedByDisplayOrderSelector = createImmutableSelector([SelectedCustomerAdditionalPropertiesSelector, SubscriberAdditionalPropertiesSelector], function (customerAdditionalProperties, subscriberAdditionalPropertyFields) {
  return getCustomerAdditionalPropertiesSortedByDisplayOrder(customerAdditionalProperties, subscriberAdditionalPropertyFields);
});

//This section is for the selectors that return the title for all of the sub-pages in customer care
export var CustomerCareDashboardWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.ACCOUNT));
  }
});
export var CustomerCareInteractionsWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.INTERACTIONS));
  }
});
export var CustomerCareAddressesWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.ADDRESSES.ADDRESSES));
  }
});
export var CustomerCareRedeemGiftOrderWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.REDEEM_GIFT_ORDER.REDEEM_GIFT_ORDER_TITLE));
  }
});
export var CustomerCareLedgerWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.BILLING_AND_PAYMENTS));
  }
});
export var CustomerCareEWalletWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.E_WALLET.TITLE));
  }
});
export var CustomerCareOfferingsWindowTitleSelector = createImmutableSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.OFFERINGS_PAGE.TITLE));
  }
});
export var CustomerCareTreatmentDetailsWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.TREATMENT_DETAILS.HEADING));
  }
});
export var CustomerCareUsageDetailsWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(i18n.translate(LocaleKeys.USAGE_DETAILS.USAGE_FOR), " ").concat(customerIdentifier);
  }
});
export var CustomerCareOrderHistoryWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.ORDER_HISTORY.TITLE));
  }
});
export var CustomerCareCasesWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.CASE.CASES));
  }
});
export var CustomerServicesWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.SERVICES));
  }
});
export var CustomerCareInventoryWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.INVENTORY.HEADING));
  }
});
export var CustomerCareActionsWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.DEMO_ACTIONS.ACTIONS));
  }
});
export var CustomerCareProfileWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.PROFILE));
  }
});
export var CustomerCareHouseholdWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.HOUSEHOLD.HOUSEHOLD));
  }
});
export var CustomerCareAccountHierarchyWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.ACCOUNT_HIERARCHY.ACCOUNT_HIERARCHY));
  }
});
export var CustomerCareCouponsWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.COUPONS.COUPONS));
  }
});
export var CustomerCareGrantCouponsWindowTitleSelector = createSelector([CurrentCustomerNameSelector], function (customerIdentifier) {
  if (customerIdentifier) {
    return "".concat(customerIdentifier, " - ").concat(i18n.translate(LocaleKeys.COUPONS.GRANT_COUPON));
  }
});
export var CustomerCareNewConnectWizardWindowTitleSelector = function CustomerCareNewConnectWizardWindowTitleSelector() {
  return i18n.translate(LocaleKeys.NEW_OFFERING_ORDER);
};
export var CurrentCustomerDevicePinStatusSelector = createSelector([SelectedCustomerSelector], function () {
  var selectedCustomer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return selectedCustomer.devicePinStatus || null;
});
export var CurrentCustomerInvoiceDetailStatus = createImmutableSelector([CurrentCustomerSelector, MetadataCodeTypeSelector(CODES.InvoiceDetailLevel)], function (customer, invoiceDetailLevels) {
  return getCustomerInvoiceDetailStatus(customer, invoiceDetailLevels);
});
export var CreateChildModelCustomerSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr({}, ['accountHierarchy', 'createChildModel', 'Customer'], selectedCustomer);
});
export var CreateCountryCurrencyValueOptions = createSelector([CreateEditCustomerSelector, CreateChildModelCustomerSelector, MetadataCodeTypeSelector(CODES.CountryCurrency)], function (customer, childCustomer, currencies) {
  return currencyValueOptionsForCountry(customer.HomeCountry || childCustomer.HomeCountry, currencies);
});
export var CustomerPreferredTaxCurrenciesSelector = createSelector([CreateEditCustomerSelector, CustomerInfoSelector, MetadataCodeTypeDictionarySelector(CODES.Currency), MetadataCodeTypeSelector(CODES.DefaultPreferredTaxReportingCurrencyConfig)], function (editCustomer, customerInfo, currencies, defaultTaxCurrencies) {
  var homeCountry = editCustomer.HomeCountry || customerInfo.HomeCountry;
  var customerId = editCustomer.Id || customerInfo.Id;
  if (Object.values(currencies).length) {
    return selectOptionsForAlphabetizedCurrencyValues(currencies, getPreferredTaxDefaultCurrency(defaultTaxCurrencies, homeCountry), customerId);
  }
  return selectOptionsForAlphabetizedCurrencyValues({}, [], customerId);
});
export var DefaultCountryCurrencySelector = createSelector([CreateEditCustomerSelector, CreateChildModelCustomerSelector, MetadataCodeTypeSelector(CODES.CountryCurrency)], function (customer, childCustomer, currencies) {
  var countryCurrencies = currencyValuesForCountry(customer.HomeCountry || childCustomer.HomeCountry, currencies) || [];
  return countryCurrencies.find(function (currencyOption) {
    return currencyOption.IsDefault;
  });
});
export var CurrentCustomerHomeCountryNameSelector = createImmutableSelector([CurrentCustomerSelector, MetadataCodeTypeSelector(CODES.AddressCountry)], function (customer, homeCountries) {
  return getCustomerHomeCountryName(customer, homeCountries);
});
export var CurrentCustomerCurrencyCodeSelector = createImmutableSelector([CurrentCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.SubscriberCurrency;
});
export var CurrentCustomerSubscriberCurrencyNameSelector = createImmutableSelector([CurrentCustomerSelector, MetadataCodeTypeSelector(CODES.Currency)], function (customer, subscriberCurrencies) {
  return getCustomerCurrencyName(customer, subscriberCurrencies);
});
export var CurrentCustomerSubscriberPreferredTaxReportingCurrencySelector = createImmutableSelector([CurrentCustomerSelector, MetadataCodeTypeSelector(CODES.Currency)], function (customer, subscriberCurrencies) {
  var selectedCurrency = subscriberCurrencies.find(function (currency) {
    return currency.Value === customer.PreferredTaxReportingCurrency;
  });
  return pathOr(customer.PreferredTaxReportingCurrency, ['Name'], selectedCurrency);
});
export var CurrentCustomerChargeTypeForDetailedTaxationSelector = createImmutableSelector([CurrentCustomerSelector], function (currentCustomer) {
  var _currentCustomer$Char2;
  var chargeTypes = getChargeTypesForDetailedTaxation();
  if ((_currentCustomer$Char2 = currentCustomer.ChargeTypesForDetailedTaxation) !== null && _currentCustomer$Char2 !== void 0 && _currentCustomer$Char2.length) {
    var formattedChargeTypes = currentCustomer.ChargeTypesForDetailedTaxation.map(function (type) {
      var chargeType = chargeTypes.find(function (cType) {
        return cType.value === type;
      });
      return chargeType.text;
    });
    return formattedChargeTypes.join(', ');
  }
  return null;
});
export var CanUserBypassResetSelector = createSelector([UserSecurityAttributesSelector], function (userSecurityAttributes) {
  return hasAccess(userSecurityAttributes, SUBSCRIBER_BYPASS_RESET_PASSWORD);
});
export var CanUserUpdatePinSelector = createSelector([UserSecurityAttributesSelector], function (userSecurityAttributes) {
  return hasAccess(userSecurityAttributes, UPDATE_PIN_ACCESS);
});
export var CanUserUpdateBillingDetailsSelector = createImmutableSelector([UserSecurityAttributesSelector], function (userSecurityAttributes) {
  return hasAccess(userSecurityAttributes, BILL_CYCLE_CHANGE_ACCESS);
});
export var CanUserPerformMiscellaneousAndItemAdjustmentSelector = createSelector([UserSecurityAttributesSelector], function (userSecurityAttributes) {
  return getSecurityAttributeById(userSecurityAttributes, ADJUSTMENT_LIMIT_AND_ACCESS.id) ? true : false;
});
export var CanUserPerformFinanceAdjustmentSelector = createSelector([UserSecurityAttributesSelector], function (userSecurityAttributes) {
  return getSecurityAttributeById(userSecurityAttributes, FINANCE_ADJUSTMENT_LIMIT_AND_ACCESS.id) ? true : false;
});
export var SubscriberStatesMapSelector = createSelector([MetadataCodeTypeSelector(CODES.SubscriberState)], function (states) {
  var statesMap = {};
  if (states && states.length) {
    var _iterator = _createForOfIteratorHelper(states),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var code = _step.value;
        var subscriberStateProperty = findAdditionalProperty(code.AdditionalProperties, 'subscriber_state_code');
        var subscriberStateCodeValue = subscriberStateProperty && parseInt(subscriberStateProperty.Value, 10);
        //An specific BU value overrides the global ones, which are the default value
        if (Number.isSafeInteger(subscriberStateCodeValue) && (!code.Global || statesMap[subscriberStateCodeValue] === undefined)) {
          statesMap[subscriberStateCodeValue] = code.Name;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return Object.keys(statesMap).length ? statesMap : EMPTY_OBJECT;
});
function findAdditionalProperty(additionalProperties, targetProperty) {
  var findPropertyByKey = function findPropertyByKey(property) {
    return property.Key === targetProperty;
  };
  return additionalProperties.find(findPropertyByKey);
}
export var IsWrappingCustomerSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.isWrappingCustomer;
});
export var CustomerWrapUpCodesSelector = createSelector([MetadataCodeTypeSelector(CODES.CustomerWrapUp)], function (customerWrapUpCodes) {
  return customerWrapUpCodes.length ? customerWrapUpCodes : EMPTY_ARRAY;
});
export var CustomerEnabledWrapUpCodesSelector = createSelector([CustomerWrapUpCodesSelector], function (customerWrapUpCodes) {
  var filterEnabledReasonCodes = function filterEnabledReasonCodes(reason) {
    var enabledProp = findByKey('enabled', reason.AdditionalProperties);
    return getBoolOrDefault(pathOr(null, ['Value'], enabledProp), false);
  };
  return customerWrapUpCodes.length ? customerWrapUpCodes.filter(filterEnabledReasonCodes) : EMPTY_ARRAY;
});
export var IsSubscriberStateReloadRequiredSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return path(['reloadSubscriberState'], selectedCustomer);
});
export var CurrentCustomerCreditLimitSelector = createImmutableSelector([CurrentCustomerSelector], function (currentCustomer) {
  return pathOr(null, ['CreditCheckClassification', 'CreditLimit'], currentCustomer);
});
export var SelectedCustomerActiveProductsSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(null, ['products', 'activeProducts'], selectedCustomer);
});
export var CustomerContactPreferencesSelector = createSelector([CurrentCustomerSelector], function (currentCustomer) {
  return pathOr(EMPTY_ARRAY, ['ContactPreferences'], currentCustomer);
});

// Creates a Dictionary of the current customer contact preferences
export var CustomerContactPreferencesDictionarySelector = createSelector([CustomerContactPreferencesSelector], function (customerContactPreferences) {
  var createContactPreferencesMap = function createContactPreferencesMap(current, contactRelationship) {
    var contactMethodId = contactRelationship.ContactMethod.toString();
    current[contactRelationship.ContactEventType] ? current[contactRelationship.ContactEventType].push(contactMethodId) : current[contactRelationship.ContactEventType] = [contactMethodId];
    return current;
  };
  return Object.keys(customerContactPreferences).length ? customerContactPreferences.reduce(createContactPreferencesMap, {}) : EMPTY_OBJECT;
});

// Creates a Dictionary of the available contact preferences for the current BUNT.
export var AvailableContactPreferencesDictionarySelector = createImmutableSelector([MetadataCodeTypeDictionarySelector(CODES.ContactEvent), CustomerContactPreferencesDictionarySelector], function (contactEventTypes, customerContactPreferencesDictionary) {
  var contactEventTypesClone = clone(contactEventTypes);
  var typesKeys = Object.keys(contactEventTypesClone);
  var getContactPreferencesMap = function getContactPreferencesMap() {
    typesKeys.forEach(function (typeKey) {
      contactEventTypesClone[typeKey] = customerContactPreferencesDictionary[typeKey] || [];
    });
    return contactEventTypesClone;
  };
  return typesKeys.length ? getContactPreferencesMap() : EMPTY_OBJECT;
});

//Returns a Dictionary of the customer preferred methods of contact including a csv description for the contact method.
export var CustomerPreferredMethodOfContactSelector = createImmutableSelector([MetadataCodeTypeDictionarySelector(CODES.ContactMethod), AvailableContactPreferencesDictionarySelector], function (contactMethods, contactPreferencesDictionary) {
  var reduceToCSV = function reduceToCSV(accum, contactMethod, index) {
    var contactMethodName = pathOr('', ['Name'], contactMethods[contactMethod]);
    return index ? "".concat(accum, ", ").concat(contactMethodName) : contactMethodName;
  };
  var contactPreferencesWithDescription = {};
  var emptyContactMethodTranslation = i18n.translate(LocaleKeys.CREATE_CUSTOMER_FORM.CONTACT_PREFERENCES.CONTACT_METHODS_EMPTY_PLACEHOLDER);
  for (var _prop in contactPreferencesDictionary) {
    contactPreferencesWithDescription[_prop] = contactPreferencesDictionary[_prop].reduce(reduceToCSV, '') || emptyContactMethodTranslation;
  }
  return Object.keys(contactPreferencesWithDescription).length ? contactPreferencesWithDescription : EMPTY_OBJECT;
});
export var ShoppingCartItemsSelector = createImmutableSelector([StoreOrderShoppingCartSelector], function (shoppingCart) {
  return shoppingCart.Items;
});
export var OfferingIdSelector = createImmutableSelector([ShoppingCartItemsSelector], function (shoppingCartItems) {
  return shoppingCartItems && shoppingCartItems.length && shoppingCartItems[0] ? shoppingCartItems[0].OfferingId : undefined;
});
export var OfferingInstanceIdSelector = createImmutableSelector([ShoppingCartItemsSelector], function (shoppingCartItems) {
  return shoppingCartItems && shoppingCartItems.length && shoppingCartItems[0] ? shoppingCartItems[0].OfferingInstanceId : undefined;
});
export var CurrentCustomerAdjustmentDueDaysSelector = createImmutableSelector([CurrentCustomerSelector], function (customer) {
  var _customer$SubscriberT;
  return Number.isInteger(customer === null || customer === void 0 ? void 0 : (_customer$SubscriberT = customer.SubscriberTypeDetails) === null || _customer$SubscriberT === void 0 ? void 0 : _customer$SubscriberT.AdjustmentDueDays) ? customer.SubscriberTypeDetails.AdjustmentDueDays : '';
});
export var CurrentCustomerPaymentDueDaysSelector = createImmutableSelector([CurrentCustomerSelector], function (customer) {
  var _customer$SubscriberT2;
  return Number.isInteger(customer === null || customer === void 0 ? void 0 : (_customer$SubscriberT2 = customer.SubscriberTypeDetails) === null || _customer$SubscriberT2 === void 0 ? void 0 : _customer$SubscriberT2.PaymentDueDays) ? customer.SubscriberTypeDetails.PaymentDueDays : '';
});
export var CurrentCustomerAccountingMethodSelector = createImmutableSelector([CurrentCustomerSelector], function (customer) {
  return customer.SubscriberTypeDetails ? customer.SubscriberTypeDetails.AccountingMethod : null;
});
export var IsPIIDataAccessEnabledSelector = createImmutableSelector([FeatureTogglesSelector, UserSecurityAttributesSelector], function (featureToggle, userSecurityAttributes) {
  return !(featureToggle[FeatureToggleConstants.ENABLE_ACCESS_RESTRICTION_TO_PII_DATA] && !hasAccess(userSecurityAttributes, PII_ACCESS));
});